import getI18N from '../lib/i18n';
import { INTL_APP_CODE, RU_APP_CODE } from './constants';

const i18n = getI18N();

export const getConfig = (appCode: string = RU_APP_CODE) => {
    const config = {
        yango: {
            defaultGeoPoint: { lon: '55.35280407014468', lat: '25.249030700257133' },
            proxyUrl:
                'https://{app}.go.link/route?start-lat={start-lat}&start-lon={start-lon}&end-lat={end-lat}&end-lon={end-lon}&tariffClass={tariff}&adj_campaign=widget&ref={ref}&adj_adgroup={ref}&adj_t={redirect}&lang={lang}&erid={erid}&data-app={app}&adj_deeplink_js=1&adj_fallback=https://yango.com/en_int/order/?gfrom={start-lon},{start-lat}&gto={end-lon},{end-lat}&ref={ref}',
            // описание кодов редиректа: https://yandex.ru/dev/taxi/doc/dg/concepts/deeplinks.html
            redirectCode: 'vokme8e_nd9s9z9',
            taxiApiUrl: 'https://yandex.com/dev/apitaxi/',
            generatedUrlPostfix: '&adj_deeplink_js=1',
            localisation: {
                legalUrl: i18n('widgetgenerator.legal.url.yango'),
                defaultAddress: i18n('widgetgenerator.yango.defaultAddress'),
                optionOrderIn: i18n('widgetgenerator.yango.badge.orderInYango'),
                optionGetRide: i18n('widgetgenerator.yango.badge.getRidetitle'),
            },
        },
        yandex: {
            defaultGeoPoint: { lon: '37.588144', lat: '55.733842' },
            proxyUrl:
                'https://{app}.redirect.appmetrica.yandex.com/route?start-lat={start-lat}&start-lon={start-lon}&end-lat={end-lat}&end-lon={end-lon}&tariffClass={tariff}&ref={ref}&appmetrica_tracking_id={redirect}&lang={lang}&erid={erid}',
            redirectCode: '1178268795219780156',
            taxiApiUrl: 'https://tech.yandex.ru/taxi/taxiapi/',
            localisation: {
                legalUrl: i18n('widgetgenerator.legal.url.yandex'),
                defaultAddress: i18n('widgetgenerator.yandex.defaultAddress'),
                optionOrderIn: i18n('widgetgenerator.yandex.badge.orderInYandex'),
                optionGetRide: i18n('Вызвать такси'),
            },
            generatedUrlPostfix: '',
        },
    };
    if (appCode === INTL_APP_CODE) {
        return config.yango;
    }
    return config.yandex;
};
